import { EntityService } from '../../service/EntityService';

export class PrintConfigService extends EntityService {

  static entity = 'app/print-config';
}
